
export default class CnhController {
    constructor(resource) {
        this._resource = resource
    }

    async uploadPhotos(data, internal){
        let route = internal ? 'cnhUpload/profile/photo' : 'cnhUpload/photo'
        return await this._resource(route)
            .save( data )
            .then( res => res.body)
            .catch( e => { throw e })
    }

    async compararSelfie(data){
        return await this._resource('cnhVerify/photo')
            .save( data )
            .then( res => res.body)
            .catch( e => { throw e })
    }

    async consultarCnhValidaByUserId(){
        return await this._resource(`cnh/user`)
            .get()
            .then( res => res.body)
            .catch( e => { throw e })
    } 


}